Ext.define('SA.VectorMapZoomSlider', {
    alias: 'widget.vector-map-zoom-slider',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-vector-map-zoom-slider',

    initComponent() {
        var zoomRange = SA.VectorMapConstants.getThematicMapZoomRange();

        this.items = [
            {
                xtype: 'component',

                autoEl: {
                    cls: 'sa-vector-map-zoom-slider-zoom-in',
                    title: 'Zoom in',

                    cn: [{
                        cls: 'sa-vector-map-zoom-slider-button'
                    }]
                },

                listeners: {
                    afterrender: cmp => {
                        var btn = cmp.el.down('.sa-vector-map-zoom-slider-button');

                        cmp.mon(btn, 'click', this.onZoomInButtonClick, this);
                    }
                }
            }, {
                xtype: 'simple-container',
                cls: 'sa-vector-map-zoom-slider-wrap-outer',

                items: [{
                    xtype: 'simple-container',
                    cls: 'sa-vector-map-zoom-slider-wrap-middle',

                    items: [{
                        xtype: 'simple-container',
                        cls: 'sa-vector-map-zoom-slider-wrap-inner',

                        items: [{
                            animate: false,
                            decimalPrecision: false,
                            height: 208,
                            margin: 0,
                            maxValue: zoomRange.getMaximum(),
                            minValue: zoomRange.getMinimum(),
                            useTips: false,
                            value: 0,
                            vertical: true,
                            xtype: 'slider',
                            listeners: {
                                changecomplete: this.onSliderChangeComplete,
                                drag: this.onSliderDrag,

                                scope: this
                            }
                        }]
                    }]
                }]
            }, {
                xtype: 'component',

                autoEl: {
                    cls: 'sa-vector-map-zoom-slider-zoom-out',
                    title: 'Zoom out',

                    cn: [{
                        cls: 'sa-vector-map-zoom-slider-button'
                    }]
                },

                listeners: {
                    afterrender: cmp => {
                        var btn = cmp.el.down('.sa-vector-map-zoom-slider-button');

                        cmp.mon(btn, 'click', this.onZoomOutButtonClick, this);
                    }
                }
            }
        ];

        this.callParent();

        this.slider = this.down('slider');
    },

    getZoom() {
        return this.slider.getValue();
    },

    onSliderChangeComplete() {
        this.fireEvent('userchange');

        this.fireEvent('userchangeend');
    },

    onSliderDrag() {
        this.fireEvent('userchange');
    },

    onUserChange(callback, scope) {
        this.on('userchange', callback, scope);
    },

    onUserChangeEnd(callback, scope) {
        this.on('userchangeend', callback, scope);
    },

    onZoomInButtonClick() {
        this.fireEvent('click:zoomIn');
    },

    onZoomInClick(callback, scope) {
        this.on('click:zoomIn', callback, scope);
    },

    onZoomOutButtonClick() {
        this.fireEvent('click:zoomOut');
    },

    onZoomOutClick(callback, scope) {
        this.on('click:zoomOut', callback, scope);
    },

    setZoom(zoom) {
        this.slider.setValue(zoom);
    }
});